export const SCHEDULING_LINK_MODAL_ID = "x_scheduling_link_modal";
